import React, { useState } from "react";
import useFilters from "../../../../../hooks/useFilters";

interface Props {
  placeholder: string
  filterKey: string
  currency?: boolean
  search?: boolean
  filterTable?: () => void
}

const InputFilter: React.FC<Props> = ({ placeholder, filterKey, currency = false, search = false, filterTable }) => {
  const { addFilter, getActiveFilters } = useFilters()
  const [value, setValue] = useState<string>('')
  const removed = Object.keys(getActiveFilters()).includes(filterKey) ? false : true

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (filterTable && event.key === "Enter") {
      filterTable()
    }
  }

  return (
    <input type="text"
      placeholder={placeholder}
      value={removed ? '' : value}
      onChange={(e) => {
        if (currency) {
          const amount = parseInt(e.target.value)
          if (Number.isNaN(amount)) {
            setValue('')
          } else {
            setValue(e.target.value)
            addFilter(filterKey, parseInt(e.target.value) * 100)
          }
        } else {
          setValue(e.target.value)
          addFilter(filterKey, e.target.value)
        }
      }}
      onKeyDown={handleKeyDown}
      className={`placeholder:text-sm placeholder:text-gray-400 h-10  ${search ? 'border border-gray-400 w-[200px] rounded-xl' : 'border-transparent w-[302px] rounded-2xl'} focus:border focus:border-cents-black bg-cents-white focus:ring-0 focus:outline-none`}
    />
  )
}

export default InputFilter;
